'use strict';

angular.module('userSettings', []);
